// import axios from "axios";
import { exportFile, get, del, patch,put, post, postform, putform,patchform } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};
//verify 2FA
//const verifyAccountApi = data => post(url.VERIFY2FA, data);
// Login Method
const postLogin = data => post(url.POST_LOGIN, data);
const postRegister = data => post(url.POST_REGISTER, data);
const getForgotPassword = (data) => patch(url.FORGOT_PASSWORD, data);
const getResetPassword = data => patch(`${url.RESET_PASSWORD}`, data);
const activateAccount = data => post(`${url.ACTIVATE_ACCOUNT}?token=${data.token}`)

// users api
const getUserRoleList = (data) => get(url.GET_USERROLE, data)

// USER 
const postAddUser = (data) => post(url.ADD_NEW_USER, data);
const patchUpdateUser = (data) => patch(url.UPDATE_USER, data);
const deleteUserById = (userId) => del(`${url.DELETE_USER}/${userId}`);
const getAllUsers = (data, exportname) => data.isExport == true ? exportFile(`${url.GET_ALL_USERS}?&IsExport=${data.isExport}`, data, `${exportname}Report.xlsx`) : get(`${url.GET_ALL_USERS}?&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}`, data);

//
const postChangePassword = (data) => patch(url.CHANGE_PASSWORD, data);
const postUpdateProfile = (data) => post(url.UPDATE_PROFILE, data);
const getViewProfile = (userId) => get(`${url.VIEW_PROFILE}?userId=${userId}`);

// manage user deactivate and activate account api 
const patchActivateUserAccount = userId => patch(`${url.PATCH_ACTIVATE_USER}?userId=${userId}`);
const patchDeactivateUserAccount = userId => patch(`${url.PATCH_DEACTIVATE_USER}?userId=${userId}`);


//CLIENT
const getAllClients = (data, exportname) => data.isExport == true ? exportFile(`${url.GET_ALL_CLIENTS}?&IsExport=${data.isExport}`, data, `${exportname}Report.xlsx`) : 
get(`${url.GET_ALL_CLIENTS}?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}`, data);
const postAddClient = (data) => postform(url.ADD_NEW_CLIENT, data);
const patchUpdateClient = (data) => putform(url.UPDATE_CLIENT, data);
const deleteClientById = (userId) => del(`${url.DELETE_CLIENT}/${userId}`);


// GET CATEGORY
const getallCategory = (data) => get(url.GET_ALL_CATEGORYS, data)

//GET CHANGETYPE
const getallChangetype = (data) => get(url.GET_ALL_CHANGETYPE, data)

//SITE 
const getAllSites = (data) => get(url.GET_ALL_SITES, data)
const postAddSite = (data) => post(url.ADD_NEW_SITE, data);
const patchUpdateSite = (data) => put(url.UPDATE_SITE, data);
const deleteSiteById = (siteId) => del(`${url.DELETE_SITE}/${siteId}`);
const getSitebyCliendId = (data, exportname) => data.isExport == true ? exportFile(`${url.GET_SITE_BY_CLIENTID}?clientId=${data.clientId}&IsExport=${data.isExport}`, data, `${exportname}Report.xlsx`) :  get(`${url.GET_SITE_BY_CLIENTID}?clientId=${data.clientId}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}`, data);
//const getListBySiteId = (siteId) => del(`${url.GET_LIST_BY_SITEID}/${siteId}`);

//MANUAL
const postAddManual = (data) =>  postform(url.ADD_MANUAL, data);
const patchUpdateManual = (data) => put(url.UPDATE_MANUAL, data);
const deleteManualById = (Id) => del(`${url.DELETE_MANUAL}/${Id}`);
const getallManuals = (data) => get(url.GET_ALL_MANUAL, data);
const getManualbySiteId = (data) => get(`${url.GET_MANUAL_BY_SITEID}?SiteId=${data.siteId}`, data);
const getManualbyClientId = (data) => {
  return get(`${url.GET_MANUAL_BY_SITEID}?clientId=${data.clientId}`, data);
};

//DRAWING
const postAddDrawing = (data) => postform(url.ADD_DRAWING, data);
const patchUpdateDrawing = (data) => patchform(url.UPDATE_DRAWING, data);
const deleteDrawingById = (id) => del(`${url.DELETE_DRAWING}?id=${id}`);
// const getDrawingbySiteId = (data, exportname) => data.isExport == true ? exportFile(`${url.GET_DRAWING_BY_SITEID}?siteid=${data.siteId}&IsExport=${data.isExport}`, data, `${exportname}Report.xlsx`) : 
//  get(`${url.GET_DRAWING_BY_SITEID}?siteid=${data.siteId}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}`, data);


const getDrawingbySiteId = (data, exportname) => {
  const categoryParam = data.categoryId ? `&categoryId=${data.categoryId}` : '';

  return data.isExport
    ? exportFile(
        `${url.GET_DRAWING_BY_SITEID}?siteid=${data.siteId}&IsExport=${data.isExport}${categoryParam}`, 
        data, 
        `${exportname}Report.xlsx`
      )
    : get(
        `${url.GET_DRAWING_BY_SITEID}?siteid=${data.siteId}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}${categoryParam}`, 
        data
      );
};

//CHANGEREQUEST
const postAddChangeRequest = (data) => postform(url.ADD_CHANGEREQUEST, data);
const getChangeRequestbySiteId = (data, exportname) => data.isExport == true ? exportFile(`${url.GET_CHANGEREQUEST_BY_SITEID}?SiteId=${data.siteId}&IsExport=${data.isExport}`, data, `${exportname}Report.xlsx`) : 
get(`${url.GET_CHANGEREQUEST_BY_SITEID}?SiteId=${data.siteId}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchKeyword=${data.searchKeyword}`, data);


export {
  //verifyAccountApi, 
  postRegister,
  postLogin,
  getForgotPassword,
  getResetPassword,
  getAllUsers,
  activateAccount,
  postChangePassword,
  postUpdateProfile,
  getViewProfile,
  patchActivateUserAccount,
  patchDeactivateUserAccount,
  postAddUser,
  getAllClients,
  patchUpdateUser,
  deleteUserById,
  postAddClient,
  patchUpdateClient,
  deleteClientById,
  getAllSites,
  deleteSiteById,
  patchUpdateSite,
  postAddSite,
  getallManuals,
  getSitebyCliendId,
  getDrawingbySiteId,
  //getListBySiteId,
  getManualbySiteId,
  getManualbyClientId,
  getallCategory,
  postAddManual,
  getUserRoleList,
  patchUpdateManual,
  deleteManualById,
  postAddDrawing,
  patchUpdateDrawing,
  deleteDrawingById,
  getChangeRequestbySiteId,
  getallChangetype,
  postAddChangeRequest
};
